import { render, staticRenderFns } from "./CheckoutMobileFooter.vue?vue&type=template&id=d5289a86&"
import script from "./CheckoutMobileFooter.vue?vue&type=script&lang=ts&"
export * from "./CheckoutMobileFooter.vue?vue&type=script&lang=ts&"
import style0 from "./CheckoutMobileFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports